import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ChoiceChipSelected from './components/choice-selected';
import ChoiceChipListed from './components/choice-listed';
import ChoiceValidated from './components/choice-validated';
import { LeftFade, RightFade, Wrapper } from './components';
import { modernBrowser } from '../../lib/utils';

import { Show } from '../show';

const ChoiceChip = ({ disabled, id, handleClick, type, validationType, value, badgeIndex, useIconsForValidation }) => {
    const [scroll, setScroll] = useState(false);
    const [overflow, setOverflow] = useState(false);
    const isModernBrowser = modernBrowser();
    let Chip = null;

    const scrolling = (ref, rendered = true) => {
        if (rendered) {
            const offsetWidth = ref.current ? ref.current.offsetWidth : 0;
            const scrollWidth = ref.current ? ref.current.scrollWidth : 0;
            const scrollLeft = ref.current ? ref.current.scrollLeft : 0;
            const scrolledWidth = scrollLeft + offsetWidth;
            setScroll(scrollLeft > 0);
            setOverflow(scrollWidth > scrolledWidth);
        }
    };

    switch (type) {
        case 'validated':
            Chip = ChoiceValidated;
            break;
        case 'selected':
            Chip = ChoiceChipSelected;
            break;
        case 'listed':
        default:
            Chip = ChoiceChipListed;
    }

    return (
        <Wrapper className="choiceChip">
            <Chip
                badgeIndex={badgeIndex}
                useIconsForValidation={useIconsForValidation}
                scrollingFn={scrolling}
                disabled={disabled}
                id={id}
                handleClick={handleClick}
                value={value}
                type={validationType}
            />
            <Show when={isModernBrowser}>
                {type !== 'validated' && <LeftFade isScrolling={scroll} type={type} />}
                <RightFade overflowing={overflow} type={type} validationType={validationType} />
            </Show>
        </Wrapper>
    );
};

ChoiceChip.propTypes = {
    badgeIndex: PropTypes.string,
    disabled: PropTypes.bool,
    handleClick: PropTypes.func,
    id: PropTypes.string,
    type: PropTypes.oneOf(['listed', 'selected', 'validated']),
    validationType: PropTypes.oneOf(['error', 'success', 'warning', 'missing']),
    value: PropTypes.string,
    useIconsForValidation: PropTypes.bool,
};

export default ChoiceChip;
